import { render } from "./ListModel.vue?vue&type=template&id=6bc05a95&scoped=true"
import script from "./ListModel.vue?vue&type=script&lang=js"
export * from "./ListModel.vue?vue&type=script&lang=js"

import "./ListModel.vue?vue&type=style&index=0&id=6bc05a95&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc05a95"]])

export default __exports__